import { render, staticRenderFns } from "./ClicDropdown.vue?vue&type=template&id=37fecf89&scoped=true&"
import script from "./ClicDropdown.vue?vue&type=script&lang=js&"
export * from "./ClicDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ClicDropdown.vue?vue&type=style&index=0&id=37fecf89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fecf89",
  null
  
)

export default component.exports